import 'angular:locale/data:en-US';
import '@angular/localize/init';
import 'core-js/modules/es.object.has-own.js';
import 'core-js/modules/es.array.find-last.js';
import 'core-js/modules/es.array.find-last-index.js';
import 'core-js/modules/es.array.at.js';
import 'core-js/modules/esnext.string.at.js';(globalThis.$localize ??= {}).locale = "en-US";
